import { CoreIcon } from '../core-icon';
import linkSVG from '../../assets/icons/link.svg';
import type { IconProps } from '../core-icon';

export const LinkIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={linkSVG} {...props} />;
};
